import React, { useState } from 'react';
import { connect } from 'react-redux';
import HandPickedPackages from './HandPickedPackages';

import './styles.scss';

const AboutPackages = ({ seoMetaData }) => {
  const [showDesc, setShowDesc] = useState(false);
  const { meta_desc_block_title, commonString, metaDescHyperlinkText, metaDescription } =
    seoMetaData || {};

  const handleViewMore = () => {
    setShowDesc(true);
  };

  return (
    <div className="abtpackages">
      <div dangerouslySetInnerHTML={{ __html: meta_desc_block_title }} suppressHydrationWarning />
      <div className={`descBlockExtraText ${showDesc ? '' : 'collapsedAboutSection'}`}>
        <div
          className="commonString"
          dangerouslySetInnerHTML={{ __html: commonString }}
          suppressHydrationWarning
        />
        <div className="readMoreContent">
          <div
            dangerouslySetInnerHTML={{ __html: metaDescHyperlinkText }}
            suppressHydrationWarning
          />
          <HandPickedPackages />
          <div
            className="descBlockExtraText"
            dangerouslySetInnerHTML={{ __html: metaDescription }}
            suppressHydrationWarning
          />
        </div>
        {!showDesc && (
          <span onClick={handleViewMore} className="viewMore">
            View More
          </span>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ seo }) => ({
  seoMetaData: seo.metaData,
});

export default connect(mapStateToProps, null)(AboutPackages);
